var _rect, _path, _path2, _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDiraIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 86,
    height: 86,
    viewBox: "0 0 86 86",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.719238,
    y: 0.986145,
    width: 84.6156,
    height: 84.6156,
    rx: 24.7897,
    fill: "#202020"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M71.7216 56.0956C71.7779 60.7638 67.649 64.2288 63.0098 63.7067C48.3052 62.0516 35.9403 55.014 29.7986 43.2213C27.2119 38.2547 25.949 32.8671 25.8822 27.3232C25.8259 22.655 29.9548 19.19 34.594 19.7121C49.2986 21.3672 61.6634 28.4048 67.8052 40.1975C70.3919 45.1641 71.6547 50.5517 71.7216 56.0956Z",
    fill: "#00FFE0",
    fillOpacity: 0.8
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M70.6075 54.3444C72.4469 57.7423 70.7934 61.8843 67.1744 63.2378C53.1772 68.4728 38.3382 67.6973 26.6401 59.7198C21.3787 56.1318 17.2417 51.4204 14.2603 45.9624C12.4071 42.5698 14.0464 38.4194 17.6631 37.0544C31.6526 31.7746 46.5021 32.5229 58.199 40.4997C63.4851 44.1046 67.632 48.8479 70.6075 54.3444Z",
    fill: "#00FFE0"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 3.66603,
    cy: 3.66603,
    r: 3.66603,
    transform: "matrix(-0.997195 -0.0748406 -0.0748406 0.997195 63.3142 48.8652)",
    fill: "#202020"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDiraIcon);
export default __webpack_public_path__ + "static/media/diraIcon.d581fa9f5ba255793cd0c61d8d1246ed.svg";
export { ForwardRef as ReactComponent };